import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  IGetSaidasParams,
  IGetReportBase64,
  IReportAgendamentoFilterParams,
  IGetQuantidadeVeiculosPatioParams,
  IGetQuantidadeVeiculosPatioListParams,
  IGetQuantidadeVeiculosPatioListResponse,
  IReportServicosEntradaFilterParams,
  IGetRelatorioLaudosEditadosListParams,
  IGetRelatorioLaudosEditadosListResponse,
  IGetHistoricoVeiculoListParams,
  IGetHistoricoVeiculoListResponse,
  IGetRelatorioLaudosExcluidosCanceladosListParams,
  IGetRelatorioLaudosExcluidosCanceladosListResponse,
  IGetRelatorioTerminalListParams,
  IGetRelatorioTerminalListResponse,
  IGetRelatorioLaudoServicoListParams,
  IGetRelatorioLaudoServicoListResponse,
  IGetReportLaudoServicoParams,
  IGetRelatorioFinanceiroPatioListParams,
  IGetRelatorioFinanceiroPatioListResponse,
  IGetReportFinanceiroPatioParams,
  IGetRelatorioPlacasCaixaListParams,
  IGetRelatorioPlacasCaixaListResponse,
  IGetReportPlacasCaixaParams,
  IGetRelatorioClientesCaixaListParams,
  IGetRelatorioClientesCaixaListResponse,
  IGetReportClientesCaixaParams,
  IGetRelatorioVendasPorProdutoParams,
  IGetRelatorioVendasPorProdutoListResponse
} from './report.model';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  constructor(private http: HttpClient) {}

  public GetAgendamentoFilter(
    params?: IReportAgendamentoFilterParams
  ): Observable<any> {
    const url = `${environment.baseURL}Report/GetReportAgendamentosFilter`;
    let httpParams = new HttpParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (
          value !== null &&
          value !== undefined &&
          String(value).trim() !== ''
        ) {
          httpParams = httpParams.set(key, String(value));
        }
      });
    }
    return this.http.get<any>(url, { params: httpParams });
  }

  public GetPreco(): Observable<any> {
    const url = `${environment.baseURL}Report/GetReportPrecos`;

    return this.http.get<any>(url);
  }

  public GetEmpresa(): Observable<any> {
    const url = `${environment.baseURL}Report/GetReportEmpresas`;

    return this.http.get<any>(url);
  }

  public GetEntradaGate(params?: {
    DT_GATE_ENTR_INIC?: string | null;
    DT_GATE_ENTR_FIM?: string | null;
    PK_GATE_ENTR?: number | string | null;
    PK_EPSA?: number | string | null;
    NM_MTRT?: string | null;
    TX_PLCA_CAVA?: string | null;
    NU_SAID_STTS?: number | string | null;
  }): Observable<any> {
    const url = `${environment.baseURL}Report/GetReportGateEntradas`;
    let httpParams = new HttpParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value === null || value === undefined || value === '') {
          return;
        }
        if (typeof value === 'number' && (Number.isNaN(value) || value === 0)) {
          return;
        }
        if (typeof value === 'string' && value.trim() === '') {
          return;
        }
        if (
          typeof value === 'string' &&
          value.trim() !== '' &&
          !Number.isNaN(Number(value)) &&
          Number(value) === 0
        ) {
          return;
        }
        httpParams = httpParams.set(key, String(value));
      });
    }
    return this.http.get<any>(url, { params: httpParams });
  }

  public GetReportServicosEntradas(
    params?: IReportServicosEntradaFilterParams
  ): Observable<IGetReportBase64> {
    const url = `${environment.baseURL}Report/GetReportServicosEntradas`;
    let httpParams = new HttpParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (
          value !== null &&
          value !== undefined &&
          String(value).trim() !== ''
        ) {
          httpParams = httpParams.set(key, String(value));
        }
      });
    }
    return this.http.get<IGetReportBase64>(url, { params: httpParams });
  }

  public GetQuantidadeVeiculosPatioPdf(
    params?: IGetQuantidadeVeiculosPatioParams
  ): Observable<IGetReportBase64> {
    return this.getReportExcel(
      `${environment.baseURL}Report/GetReportQuantidadeVeiculosPatioPdf`,
      (params ?? {}) as Record<string, unknown>
    );
  }

  public GetQuantidadeVeiculosPatio(
    params?: IGetQuantidadeVeiculosPatioParams
  ): Observable<IGetReportBase64> {
    const url = `${environment.baseURL}Report/GetReportQuantidadeVeiculosPatio`;

    let httpParams = new HttpParams();

    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
          httpParams = httpParams.set(key, String(value));
        }
      });
    }

    return this.http.get<IGetReportBase64>(url, { params: httpParams });
  }

  public GetQuantidadeVeiculosPatioList(
    params: IGetQuantidadeVeiculosPatioListParams
  ): Observable<IGetQuantidadeVeiculosPatioListResponse> {
    const url = `${environment.baseURL}Report/GetQuantidadeVeiculosPatio`;

    let httpParams = new HttpParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });

    return this.http.get<IGetQuantidadeVeiculosPatioListResponse>(url, {
      params: httpParams
    });
  }

  public GetSaidaGate(params?: IGetSaidasParams): Observable<IGetReportBase64> {
    const url = `${environment.baseURL}Report/GetReportGateSaidas`;

    let httpParams = new HttpParams();
  
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
          httpParams = httpParams.set(key, String(value));
        }
      });
    }
  
    return this.http.get<IGetReportBase64>(url, { params: httpParams });
  }

  public GetRelatorioLaudosEditados(
    params: IGetRelatorioLaudosEditadosListParams
  ): Observable<IGetRelatorioLaudosEditadosListResponse> {
    const url = `${environment.baseURL}Report/GetRelatorioLaudosEditados`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetRelatorioLaudosEditadosListResponse>(url, { params: httpParams });
  }

  public GetHistoricoVeiculo(
    params: IGetHistoricoVeiculoListParams
  ): Observable<IGetHistoricoVeiculoListResponse> {
    const url = `${environment.baseURL}Report/GetHistoricoVeiculo`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetHistoricoVeiculoListResponse>(url, { params: httpParams });
  }

  public GetRelatorioTerminal(
    params: IGetRelatorioTerminalListParams
  ): Observable<IGetRelatorioTerminalListResponse> {
    const url = `${environment.baseURL}Report/GetRelatorioTerminal`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetRelatorioTerminalListResponse>(url, { params: httpParams });
  }

  public GetRelatorioLaudosExcluidosCancelados(
    params: IGetRelatorioLaudosExcluidosCanceladosListParams
  ): Observable<IGetRelatorioLaudosExcluidosCanceladosListResponse> {
    const url = `${environment.baseURL}Report/GetRelatorioLaudosExcluidosCancelados`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetRelatorioLaudosExcluidosCanceladosListResponse>(url, { params: httpParams });
  }

  public GetOrdemServico(
    FK_EPSA: number,
    DT_SRVC_ENTR_INIC: string,
    DT_SRVC_ENTR_FIM: string
  ): Observable<any> {
    const params: any = {};

    if (FK_EPSA !== undefined) {
      params.FK_EPSA = FK_EPSA;
    }
    if (
      DT_SRVC_ENTR_INIC !== undefined &&
      String(DT_SRVC_ENTR_INIC).trim() !== ''
    ) {
      params.DT_SRVC_ENTR_INIC = DT_SRVC_ENTR_INIC;
    }
    if (
      DT_SRVC_ENTR_FIM !== undefined &&
      String(DT_SRVC_ENTR_FIM).trim() !== ''
    ) {
      params.DT_SRVC_ENTR_FIM = DT_SRVC_ENTR_FIM;
    }

    const url = `${environment.baseURL}Report/GetReportOrdemServico`;

    return this.http.get<any>(url, { params });
  }

  public GetRelatorioLaudoServico(
    params: IGetRelatorioLaudoServicoListParams
  ): Observable<IGetRelatorioLaudoServicoListResponse> {
    const url = `${environment.baseURL}Report/GetRelatorioLaudoServico`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetRelatorioLaudoServicoListResponse>(url, { params: httpParams });
  }

  public GetReportLaudoServico(
    params: IGetReportLaudoServicoParams
  ): Observable<IGetReportBase64> {
    const url = `${environment.baseURL}Report/GetReportLaudoServico`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetReportBase64>(url, { params: httpParams });
  }

  public GetReportLaudoServicoPdf(
    params: IGetReportLaudoServicoParams
  ): Observable<IGetReportBase64> {
    const url = `${environment.baseURL}Report/GetReportLaudoServicoPdf`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetReportBase64>(url, { params: httpParams });
  }

  public GetRelatorioFinanceiroPatio(
    params: IGetRelatorioFinanceiroPatioListParams
  ): Observable<IGetRelatorioFinanceiroPatioListResponse> {
    const url = `${environment.baseURL}Report/GetRelatorioFinanceiroPatio`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetRelatorioFinanceiroPatioListResponse>(url, { params: httpParams });
  }

  public GetReportFinanceiroPatio(
    params: IGetReportFinanceiroPatioParams
  ): Observable<IGetReportBase64> {
    const url = `${environment.baseURL}Report/GetReportFinanceiroPatio`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetReportBase64>(url, { params: httpParams });
  }

  public GetReportFinanceiroPatioPdf(
    params: IGetReportFinanceiroPatioParams
  ): Observable<IGetReportBase64> {
    const url = `${environment.baseURL}Report/GetReportFinanceiroPatioPdf`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetReportBase64>(url, { params: httpParams });
  }

  public GetReportTerminalLaudoPdf(params: { DT_INIC?: string; DT_FIM?: string }): Observable<IGetReportBase64> {
    const url = `${environment.baseURL}Report/GetReportTerminalLaudoPdf`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetReportBase64>(url, { params: httpParams });
  }

  public GetReportCarregamentoLaudoPdf(params: { DT_INIC?: string; DT_FIM?: string; FL_DETALHADO?: boolean }): Observable<IGetReportBase64> {
    const url = `${environment.baseURL}Report/GetReportCarregamentoLaudoPdf`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetReportBase64>(url, { params: httpParams });
  }

  public GetReportClienteLaudoPdf(params: { DT_INIC?: string; DT_FIM?: string; FL_DETALHADO?: boolean }): Observable<IGetReportBase64> {
    const url = `${environment.baseURL}Report/GetReportClienteLaudoPdf`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetReportBase64>(url, { params: httpParams });
  }

  public GetReportMensalLaudoPdf(params: { DT_INIC?: string; DT_FIM?: string }): Observable<IGetReportBase64> {
    const url = `${environment.baseURL}Report/GetReportMensalLaudoPdf`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetReportBase64>(url, { params: httpParams });
  }

  public GetReportQuantidadeClienteLaudoPdf(params: { DT_INIC?: string; DT_FIM?: string }): Observable<IGetReportBase64> {
    const url = `${environment.baseURL}Report/GetReportQuantidadeClienteLaudoPdf`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetReportBase64>(url, { params: httpParams });
  }

  public GetRelatorioPlacasCaixa(
    params: IGetRelatorioPlacasCaixaListParams
  ): Observable<IGetRelatorioPlacasCaixaListResponse> {
    const url = `${environment.baseURL}Report/GetRelatorioPlacasCaixa`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetRelatorioPlacasCaixaListResponse>(url, { params: httpParams });
  }

  public GetReportPlacasCaixaExcel(
    params: IGetReportPlacasCaixaParams
  ): Observable<IGetReportBase64> {
    const url = `${environment.baseURL}Report/GetReportPlacasCaixaExcel`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetReportBase64>(url, { params: httpParams });
  }

  public GetReportPlacasCaixaPdf(
    params: IGetReportPlacasCaixaParams
  ): Observable<IGetReportBase64> {
    const url = `${environment.baseURL}Report/GetReportPlacasCaixaPdf`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetReportBase64>(url, { params: httpParams });
  }

  public GetRelatorioClientesCaixa(
    params: IGetRelatorioClientesCaixaListParams
  ): Observable<IGetRelatorioClientesCaixaListResponse> {
    const url = `${environment.baseURL}Report/GetRelatorioClientesCaixa`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetRelatorioClientesCaixaListResponse>(url, { params: httpParams });
  }

  public GetReportClientesCaixaExcel(
    params: IGetReportClientesCaixaParams
  ): Observable<IGetReportBase64> {
    const url = `${environment.baseURL}Report/GetReportClientesCaixaExcel`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetReportBase64>(url, { params: httpParams });
  }

  public GetReportClientesCaixaPdf(
    params: IGetReportClientesCaixaParams
  ): Observable<IGetReportBase64> {
    const url = `${environment.baseURL}Report/GetReportClientesCaixaPdf`;
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetReportBase64>(url, { params: httpParams });
  }

  public GetRelatorioVendasPorProduto(
    params?: IGetRelatorioVendasPorProdutoParams
  ): Observable<IGetRelatorioVendasPorProdutoListResponse> {
    const url = `${environment.baseURL}Report/GetRelatorioVendasPorProduto`;
    let httpParams = new HttpParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined && String(value).trim() !== '') {
          httpParams = httpParams.set(key, String(value));
        }
      });
    }
    return this.http.get<IGetRelatorioVendasPorProdutoListResponse>(url, { params: httpParams });
  }

  public GetReportVendasPorProdutoExcel(
    params?: IGetRelatorioVendasPorProdutoParams
  ): Observable<IGetReportBase64> {
    return this.getReportExcel(
      `${environment.baseURL}Report/GetReportVendasPorProdutoExcel`,
      (params ?? {}) as Record<string, unknown>
    );
  }

  public GetReportHistoricoVeiculoExcel(params: {
    TX_PLCA?: string;
    DT_INIC?: string;
    DT_FIM?: string;
  }): Observable<IGetReportBase64> {
    return this.getReportExcel(`${environment.baseURL}Report/GetReportHistoricoVeiculoExcel`, params);
  }

  public GetReportHistoricoVeiculoPdf(params: {
    TX_PLCA?: string;
    DT_INIC?: string;
    DT_FIM?: string;
  }): Observable<IGetReportBase64> {
    return this.getReportExcel(`${environment.baseURL}Report/GetReportHistoricoVeiculoPdf`, params);
  }

  public GetReportLaudosEditadosExcel(params: {
    TX_PLCA_CAVA?: string;
    DT_INIC?: string;
    DT_FIM?: string;
  }): Observable<IGetReportBase64> {
    return this.getReportExcel(`${environment.baseURL}Report/GetReportLaudosEditadosExcel`, params);
  }

  public GetReportLaudosEditadosPdf(params: {
    TX_PLCA_CAVA?: string;
    DT_INIC?: string;
    DT_FIM?: string;
  }): Observable<IGetReportBase64> {
    return this.getReportExcel(`${environment.baseURL}Report/GetReportLaudosEditadosPdf`, params);
  }

  public GetReportLaudosExcluidosCanceladosExcel(params: {
    TX_PLCA_CAVA?: string;
    DT_INIC?: string;
    DT_FIM?: string;
  }): Observable<IGetReportBase64> {
    return this.getReportExcel(`${environment.baseURL}Report/GetReportLaudosExcluidosCanceladosExcel`, params);
  }

  public GetReportRelatorioTerminalExcel(params: {
    PK_DTNR?: number;
    NM_DTNR?: string;
    DT_INIC?: string;
    DT_FIM?: string;
  }): Observable<IGetReportBase64> {
    return this.getReportExcel(`${environment.baseURL}Report/GetReportRelatorioTerminalExcel`, params);
  }

  public GetReportRelatorioTerminalPdf(params: {
    PK_DTNR?: number;
    NM_DTNR?: string;
    DT_INIC?: string;
    DT_FIM?: string;
  }): Observable<IGetReportBase64> {
    return this.getReportExcel(`${environment.baseURL}Report/GetReportRelatorioTerminalPdf`, params);
  }

  public GetReportTerminalLaudoExcel(params: { DT_INIC?: string; DT_FIM?: string }): Observable<IGetReportBase64> {
    return this.getReportExcel(`${environment.baseURL}Report/GetReportTerminalLaudoExcel`, params);
  }

  public GetReportCarregamentoLaudoExcel(params: {
    DT_INIC?: string;
    DT_FIM?: string;
    FL_DETALHADO?: boolean;
  }): Observable<IGetReportBase64> {
    return this.getReportExcel(`${environment.baseURL}Report/GetReportCarregamentoLaudoExcel`, params);
  }

  public GetReportClienteLaudoExcel(params: {
    DT_INIC?: string;
    DT_FIM?: string;
    FL_DETALHADO?: boolean;
  }): Observable<IGetReportBase64> {
    return this.getReportExcel(`${environment.baseURL}Report/GetReportClienteLaudoExcel`, params);
  }

  public GetReportMensalLaudoExcel(params: { DT_INIC?: string; DT_FIM?: string }): Observable<IGetReportBase64> {
    return this.getReportExcel(`${environment.baseURL}Report/GetReportMensalLaudoExcel`, params);
  }

  public GetReportQuantidadeClienteLaudoExcel(params: {
    DT_INIC?: string;
    DT_FIM?: string;
  }): Observable<IGetReportBase64> {
    return this.getReportExcel(`${environment.baseURL}Report/GetReportQuantidadeClienteLaudoExcel`, params);
  }

  private getReportExcel(url: string, params: Record<string, unknown>): Observable<IGetReportBase64> {
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return this.http.get<IGetReportBase64>(url, { params: httpParams });
  }
}
